<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M16.129 6.34982L12.83 3.38073C11.8902 2.53484 11.4203 2.11189 10.8436 1.89062L10.8359 4.16937C10.8359 6.13355 10.8359 7.11564 11.4461 7.72583C12.0564 8.33602 13.0384 8.33602 15.0026 8.33602H17.986C17.6839 7.74917 17.1429 7.26231 16.129 6.34982Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.668 18.3346H8.33464C5.19194 18.3346 3.62059 18.3346 2.64428 17.3583C1.66797 16.3821 1.66797 14.8106 1.66797 11.668V8.33464C1.66797 5.19194 1.66797 3.62059 2.64428 2.64428C3.62059 1.66797 5.20021 1.66797 8.35947 1.66797C8.86447 1.66797 9.26913 1.66797 9.60963 1.68185C9.59847 1.74846 9.59255 1.81641 9.5923 1.88511L9.58464 4.24711C9.58455 5.16136 9.58447 5.96934 9.67205 6.6206C9.76697 7.32654 9.98489 8.03235 10.561 8.60839C11.137 9.18447 11.8428 9.40239 12.5487 9.4973C13.2001 9.58489 14.008 9.5848 14.9222 9.58472H15.0013H18.2991C18.3346 10.03 18.3346 10.5764 18.3346 11.3037V11.668C18.3346 14.8106 18.3346 16.3821 17.3583 17.3583C16.3821 18.3346 14.8106 18.3346 11.668 18.3346ZM8.74989 12.0341C9.00788 12.2635 9.03105 12.6586 8.8018 12.9166L6.57954 15.4166C6.46094 15.55 6.29094 15.6263 6.11241 15.6263C5.93389 15.6263 5.76389 15.55 5.64529 15.4166L4.53417 14.1666C4.30484 13.9086 4.32809 13.5135 4.58608 13.2841C4.84406 13.0549 5.23911 13.0781 5.46844 13.3361L6.11241 14.0606L7.8675 12.0861C8.09683 11.8281 8.49188 11.8049 8.74989 12.0341Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'AssignedCasesIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>